import { memo, forwardRef } from "react";
import { ReactComponent as LeftArrow } from "../../app/newLayout/assets/svgIcon/detailsPage/left-arrow.svg";
import { StyledGoBackSpanElement } from "./atoms.styles";
import { useNavigate } from "react-router-dom";

/**
 * DetailPageGoToPreviousPageIcon
 *
 * Clickable back‑navigation icon rendered as a span; calls `navigate(step)`
 * via React Router when clicked or when Enter/Space is pressed.
 *
 * Props
 * - step (number): number of history entries to move; default `-1`.
 * - navigateURL (null): navigate to the provide url if any.
 * - ref (React.Ref<HTMLSpanElement>): forwarded ref to the outer span.
 * - …rest (HTMLAttributes<HTMLSpanElement>): additional props passed to `StyledGoBackSpanElement`.
 */

const DetailPageGoToPreviousPageIcon = memo(
  forwardRef(function DetailPageGoToPreviousPageIcon(
    { step = -1, navigateURL = null, ...rest },
    ref,
  ) {
    const navigate = useNavigate();

    const goBack = () => navigate(navigateURL || step);

    return (
      <StyledGoBackSpanElement
        aria-label="Go back"
        ref={ref}
        role="link"
        tabIndex={0}
        title="Back"
        onClick={goBack}
        onKeyDown={e => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            goBack();
          }
        }}
        {...rest} /* className, style, etc. */
      >
        <LeftArrow />
      </StyledGoBackSpanElement>
    );
  }),
);

export { DetailPageGoToPreviousPageIcon };
